// @flow

import _ from 'lodash';

import ArrayUtils from '../../utils/ArrayUtils';
import Utils from '../../utils/Utils';

import ApiObject from '../ApiObject';
import CategoryItem from './CategoryItem';

import { getLocalizedData } from '../../utils/CatalogUtils'

export default class UpsellingCategory extends ApiObject {

  static DESCRIPTION_MIN_LENGTH = 5;

  id: string = '';

  // the real used value will be the one returned by the getter
  _name: string = '';

  localizedNames: Array<> = [];

  // the real used value will be the one returned by the getter
  _description: string = '';

  localizedDescriptions: Array<> = [];

  items: Array<CategoryItem> = [];

  enabled: boolean = false;

  set name(name) {
    this._name = name
  }

  get name() {
    return getLocalizedData(this.localizedNames) || this._name || ''
  }

  set description(description) {
    this._description = description
  }

  get description() {
    return getLocalizedData(this.localizedDescriptions) || this._description || ''
  }

  postJsonAssignation(data: Object) {
    this.items = [];
    _.each(data.items, (itemData) => {
      const item: CategoryItem = new CategoryItem();
      item.fromJson(itemData);
      this.items.push(item);
    });

    if (_.isNull(this.id)) {
      this.id = Utils.generateUID();
    }
  }

  removeItemWithId(id: string) {
    this.items = _.remove(this.items, (item: CategoryItem) => {
      return item.id !== id;
    });
  }

  moveUpWithId(id: string) {
    const fromIndex = _.findIndex(this.items, (item: CategoryItem) => {
      return item.id === id;
    });

    const size = this.items.length;
    const toIndex = fromIndex - 1 >= 0 ? fromIndex - 1 : size - 1;
    this.items = ArrayUtils.moveOnArray(this.items, fromIndex, toIndex);
  }

  moveDownWithId(id: string) {
    const fromIndex = _.findIndex(this.items, (item: CategoryItem) => {
      return item.id === id;
    });

    const size = this.items.length;
    const toIndex = fromIndex + 1 < size ? fromIndex + 1 : 0;
    this.items = ArrayUtils.moveOnArray(this.items, fromIndex, toIndex);
  }

  //
  // Validation
  //

  /**
   * Verify that the object is correct
   */
  isValid(): boolean {
    return this.validateName() &&
      this.validateDescription();
  }

  validateName(): boolean {
    if (_.isEmpty(this.localizedNames)) {
      return false
    }

    let isValid = false

    _.forEach(this.localizedNames, localizedName => {
      if (!_.isEmpty(localizedName.text)) {
        isValid = true
      }
    })

    return isValid
  }

  validateDescription(): boolean {
    let isValid = true

    _.forEach(this.localizedDescriptions, localizedDescription => {
      if (!_.isEmpty(localizedDescription.text) && localizedDescription.text.length < UpsellingCategory.DESCRIPTION_MIN_LENGTH) {
        isValid = false
      }
    })

    return isValid
  }

  static validationErrors = {
    name: 'Le nom ne peut être vide',
    description: `La description doit être vide ou contenir plus de ${UpsellingCategory.DESCRIPTION_MIN_LENGTH} caractères`
  };

  getValidationErrors(): Object {
    const validationErrors = UpsellingCategory.validationErrors;
    const errors = {};

    if (!this.validateName()) {
      errors.name = validationErrors.name;
    }

    if (!this.validateDescription()) {
      errors.description = validationErrors.description;
    }

    return errors;
  }
}
